import React from 'react';
import { Box, Fade, Typography, makeStyles } from '@material-ui/core';
import { IDocumentList } from './types';
import { DocumentItem } from './DocumentItem';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(() => ({
    root: {
        maxHeight: 250,
        overflow: 'scroll',
        paddingLeft: 15,
        paddingRight: 15,
    },
    noDocumentation: {
        paddingTop: 10,
        paddingBottom: 5,
    },
}));

export const DocumentList = ({
    documents,
    mail,
    setMail,
    ...props
}: IDocumentList) => {
    const classes = useStyles();
    const { t } = useTranslation();
    return (
        <Box className={classes.root} {...props}>
            {documents.length === 0 ? (
                <Typography
                    className={classes.noDocumentation}
                    color="textSecondary"
                >
                    {t('Buttons.NoDocumentation')}
                </Typography>
            ) : (
                documents.map((document) => (
                    <Fade in timeout={600}>
                        <DocumentItem
                            document={document}
                            mail={mail}
                            setMail={setMail}
                        />
                    </Fade>
                ))
            )}
        </Box>
    );
};
